import { useCallback } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { useConfirmDialogStore } from '@/shared/stores/confirm-dialog-store';

interface UseDeleteSessionOptions {
    onConfirm: () => void | Promise<void>;
    onCancel?: () => void;
}

export function useConfirmSessionDeleteDialog() {
    const openConfirmDialog = useConfirmDialogStore((state) => state.open);
    const navigate = useNavigate();

    const openConfirmDeleteDialog = useCallback(
        ({ onConfirm, onCancel }: UseDeleteSessionOptions) => {
            openConfirmDialog({
                title: 'Delete session?',
                description: 'This session will be deleted and no note will be generated.',
                cancelText: 'Cancel',
                confirmText: 'Delete Session',
                variant: 'destructive',
                onConfirm: async () => {
                    await onConfirm();
                    void navigate({ to: '/dashboard', replace: true });
                },
                onCancel,
            });
        },
        [openConfirmDialog, navigate],
    );

    return openConfirmDeleteDialog;
}
